import {
  IconDeviceGamepad2,
  IconGrid3x3,
  IconHorseshoe,
  IconLivePhoto,
  IconSword,
  IconTicket,
  IconTrophy,
} from "@tabler/icons-react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {useAuthStore} from "../../../store/useAuth.store";
import styles from "./ButtonsNavbar.module.css";

const HEADER_ICON_PROPS = {size: 16, stroke: 2};

const ButtonsNavbar = ({sidebarCollapsed = false}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const buttons = [
    {
      label: t("games"),
      icon: <IconDeviceGamepad2 {...HEADER_ICON_PROPS} />,
      route: "/gameslist/all",
      style: {marginLeft: "60px"},
      requireAuth: false,
    },
    {
      label: t("live_casino"),
      icon: <IconLivePhoto {...HEADER_ICON_PROPS} />,
      route: "/casino",
      requireAuth: true,
      isCasino: true,
    },
    {
      label: t("lottery"),
      icon: <IconTicket {...HEADER_ICON_PROPS} />,
      route: "/lottery",
      requireAuth: false,
    },
    {
      label: t("bingo"),
      icon: <IconGrid3x3 {...HEADER_ICON_PROPS} />,
      route: "/bingo",
      requireAuth: true,
    },
    {
      label: t("horses"),
      icon: <IconHorseshoe {...HEADER_ICON_PROPS} />,
      route: "/horses",
      requireAuth: true,
    },
    {
      label: t("sports"),
      icon: <IconTrophy {...HEADER_ICON_PROPS} />,
      route: "/sports",
      requireAuth: true,
    },
    {
      label: t("e_sports"),
      icon: <IconSword {...HEADER_ICON_PROPS} />,
      route: "/games/pragmatic/vplobby",
      requireAuth: true,
    },
  ];

  const handleButtonClick = (route, requireAuth) => {
    if (requireAuth && authStatus !== "authenticated") {
      handleShowAuthModal();
      return;
    }
    navigate(route);
  };

  return (
    <div
      className={`${styles.buttonsContainer} ${sidebarCollapsed ? styles.sidebarCollapsed : styles.sidebarExpanded}`}
    >
      {buttons.map(({label, icon, route, style, requireAuth, isCasino}) => {
        const isActive = location.pathname.startsWith(route);
        const classes = [styles.buttonNavbar, isCasino ? styles.casinoButton : "", isActive ? styles.buttonActive : ""]
          .filter(Boolean)
          .join(" ");

        return (
          <button
            key={label}
            type="button"
            className={classes}
            style={style}
            onClick={() => handleButtonClick(route, requireAuth)}
          >
            <div className={styles.buttonContent}>
              {icon}
              <span className={styles.buttonText}>{label}</span>
              {isCasino && <span className={styles.liveDot} />}
            </div>
          </button>
        );
      })}
    </div>
  );
};

ButtonsNavbar.propTypes = {
  sidebarCollapsed: PropTypes.bool,
};

export default ButtonsNavbar;
